export const images = {
  logoHorizontalTeuCard: require("./images/logo-horizontal-teucard.png"),
};
